import React, { Component }  from 'react';

export default class Directory extends Component {constructor(props) {
		super(props);
		this.state = {
			active: false,
			editing: false,
			loading: false,
            filterBy: {},
            sortOrder: 1,
            sortBy: false

		};
        this.defaultContact = {
            "prefix": "",
            "firstName": "",
            "lastName": "",
            "title": "",
            "department": "",
            "email": "",

            "aliases": [],
            "sayAs": "",

            "extension": "",
            "dialString": "",



            "includeInDirectory": true,
            "announceTransfer": true
        }
	}

	add = () => {
		this.setState({editing: Object.assign({},this.defaultContact), loading: false })
	}
	edit = (contact) => (e) => {
		this.setState({editing: contact, loading: false})
	}
    conf = () => {
		this.setState({loading: true})
		this.props.ws.send(JSON.stringify({route: 'addContact', contact: this.state.editing }))
	}
    cancel = () => {
		this.setState({editing: false, loading: false, setting: false})
	}

	deleteContact = (contact) => (e) => {
        e.stopPropagation()
		this.props.ws.send(JSON.stringify({route: 'deleteContact', contact: contact.extension }))
	}

    editField = (field) => (e) => {
        var newValue = Object.assign({},this.state.editing)
        newValue[field] = e.currentTarget.value
        this.setState({editing: newValue, loading: false})
    }
    toggle = (field) => (e) => {
        var newValue = Object.assign({},this.state.editing)
        newValue[field] = newValue[field] ? false : true
        this.setState({editing: newValue, loading: false})
    }
    addAlias = (index) => (e) => {
        var newValue = Object.assign({},this.state.editing)
        newValue.aliases =  Object.assign([],this.state.editing.aliases)
        newValue.aliases[index] = e.currentTarget.value
        if(e.currentTarget.value.length < 1){
            newValue.aliases.splice(index, 1)
        }
        this.setState({editing: newValue, loading: false})
    }
    removeAlias = (index) => (e) => {
        var newValue = Object.assign({},this.state.editing)
        newValue.aliases =  Object.assign([],this.state.editing.aliases)

        newValue.aliases.splice(index, 1)

        this.setState({editing: newValue, loading: false})
    }

    playSayAs = (contact) => (e) => {
        var sayAsString
        if(contact.sayAs.length > 0){
            sayAsString = contact.sayAs
        } else if(contact.firstName.length > 0 || contact.lastName.length > 0 ){
            sayAsString = (contact.firstName + ' ' + contact.lastName)
        } else {
            sayAsString = contact.department
        }
        e.stopPropagation()
        console.log('Audio clicked!')
        var a = new Audio(window.location.origin + '/playSayAs?string=' + encodeURIComponent(sayAsString))
        a.play()
    }


    sort = (e) => {
		var sortOrder
		if(this.state.sortOrder === -1){
			sortOrder = 1;
		}else{
			sortOrder = -1;
		}
		this.setState({sortBy: e.target.getAttribute("data-sortBy"), sortOrder: sortOrder})
	}

	filter = (e) => {
		var filterBy = this.state.filterBy
		if(e.target.value.length > 0) {
			filterBy[e.target.getAttribute("data-filterBy")] = e.target.value
		} else {
			delete filterBy[e.target.getAttribute("data-filterBy")]
		}
		this.setState({filterBy: filterBy})
	}

	sortFunc(sortBy, sortOrder){
		return function(a,b) {
			if(sortBy === "status" || sortBy ==="ActivityDateTime") {
				if('status' in a && 'status' in b){
					if(!a.loggedIn && !b.loggedIn){
						return a.username > b.username ? 1 * sortOrder : -1 * sortOrder
					}else if(!a.loggedIn) {
						return 1
					}else if(!b.loggedIn) {
						return -1
					}
					if(a[sortBy] === b[sortBy]){
						return a.username > b.username ? 1 * sortOrder : -1 * sortOrder
					}
					return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
				}else {
					if('status' in a){
						return -1
					}
					return 1
				}
			}

			if(sortBy in a && sortBy in b){
				if(a[sortBy] === b[sortBy]){
					return a.username > b.username ? 1 * sortOrder : -1 * sortOrder
				}
				return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
			}else if (!(sortBy in a) && !(sortBy in b)){
				return a.username > b.username ? 1 * sortOrder : -1 * sortOrder
			}else {
				return sortBy in a ? -1 : 1
			}
		}
	}

	filterFunc(array, filterBy){
		return array.filter(function(object) {
			for(var prop in filterBy){
				if(typeof object[prop] === "undefined") {
					return false
				}
				if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
					return false
				}
			}
			return true
		})
	}

	componentWillReceiveProps(nextProps) {
		if(this.state.loading) {
			this.cancel();
		}
	}

	render() {
		if (this.props.active) {
            var contactList = [];

			for (var contact in this.props.data.Directory) {
				contactList.push(this.props.data.Directory[contact]);
			}

			//Filtering User List
			if(Object.keys(this.state.filterBy).length > 0) {
				contactList = this.filterFunc(contactList, this.state.filterBy)
			}

			//Sorting filtered User List
			if(this.state.sortBy !== '')  {
				contactList.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
			}

			var contacts = []
			for (var contact of contactList) {
                var sayAsString
                if(contact.sayAs.length > 0){
                    sayAsString = (<span style={{flex: '1 0 100px'}}>{contact.sayAs}</span>)
                } else if(contact.firstName.length > 0 || contact.lastName.length > 0 ){
                    sayAsString = (<span style={{flex: '1 0 100px', opacity: '.5'}}>{contact.firstName + ' ' + contact.lastName}</span>)
                } else {
                    sayAsString = (<span style={{flex: '1 0 100px', opacity: '.5'}}>{contact.department}</span>)

                }

				contacts.push(
					<div className="dataRow"  onClick={this.edit(contact)} key={contact.extension}>
						<span style={{flex: '0 0 125px'}}>{contact.extension}</span>
                        <span style={{flex: '0 0 150px'}}>{contact.firstName}</span>
                        <span style={{flex: '0 0 150px'}}>{contact.lastName}</span>
                        <span style={{flex: '0 0 300px'}}>{contact.department}</span>
                        {sayAsString}
						<span className="buttonBox" style={{flex: '0 0 80px'}}>
                            <img src={this.props.img.speaker} alt="Play Name" onClick={this.playSayAs(contact)} />
							<img src={this.props.img.delete} alt="Delete Exclusion" onClick={this.deleteContact(contact)} />
						</span>
					</div>
				)
			}
			var edit = ""
			if (this.state.editing) {
                var aliasArray = []
                this.state.editing.aliases.forEach((alias, index) => {
                    aliasArray.push(
                        <div style={{flex: '0 0 25%',position: 'relative' }} key={index}>
                            <input style={{margin: '10px 15px'}} className="textInput" type="text" required value={alias} onChange={this.addAlias(index)} ></input>
                            <div style={{position: 'absolute', top: '18px', right: '8px'}} onClick={this.removeAlias(index)}>X</div>
                        </div>
                    )
                })
                aliasArray.push(
                    <div style={{flex: '0 0 25%',position: 'relative' }} key={this.state.editing.aliases.length}>
                        <input style={{margin: '10px 15px'}} placeholder="Enter New Alias"  className="textInput" type="text" required value={""} onChange={this.addAlias(this.state.editing.aliases.length)} ></input>
                    </div>
                )

                if(this.state.editing.sayAs.length > 0){
                    sayAsString = this.state.editing.sayAs
                } else if(this.state.editing.firstName.length > 0 || this.state.editing.lastName.length > 0 ){
                    sayAsString = (this.state.editing.firstName + ' ' + this.state.editing.lastName)
                } else {
                    sayAsString = this.state.editing.department
                }

				edit = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}>X</div>

                            <div style={{minWidth:'700px'}}>
    							<div style={{display:'inline-block', width: 'unset' }} className="snazzyInputBox">
    								<input className="textInput" type="text" required value={this.state.editing.prefix} onChange={this.editField('prefix')} ></input>
    								<span className="inputBar"></span><label className="textLabel">Prefix</label>
    							</div>

    							<div  style={{display:'inline-block', width: 'unset'}} className="snazzyInputBox">
    								<input className="textInput" type="text" required value={this.state.editing.firstName} onChange={this.editField('firstName')} ></input>
    								<span className="inputBar"></span><label className="textLabel">First Name</label>
    							</div>

                                <div style={{display:'inline-block', width: 'unset'}} className="snazzyInputBox">
    								<input className="textInput" type="text" required value={this.state.editing.lastName} onChange={this.editField('lastName')} ></input>
    								<span className="inputBar"></span><label className="textLabel">Last Name</label>
    							</div>
                            </div>

                            <div style={{minWidth:'700px'}}>
    							<div style={{display:'inline-block', width: 'unset'}} className="snazzyInputBox">
    								<input className="textInput" type="text" required value={this.state.editing.title} onChange={this.editField('title')} ></input>
    								<span className="inputBar"></span><label className="textLabel">Title</label>
    							</div>

    							<div  style={{display:'inline-block', width: 'unset'}} className="snazzyInputBox">
    								<input className="textInput" type="text" required value={this.state.editing.department} onChange={this.editField('department')} ></input>
    								<span className="inputBar"></span><label className="textLabel">Department</label>
    							</div>

                                <div style={{display:'inline-block', width: 'unset'}} className="snazzyInputBox">
    								<input className="textInput" type="text" required value={this.state.editing.email} onChange={this.editField('email')} ></input>
    								<span className="inputBar"></span><label className="textLabel">Email</label>
    							</div>
                            </div>
                            <div style={{minWidth:'700px'}}>
    							<div style={{display:'inline-block'}} className="snazzyInputBox">
    								<input className="textInput" type="text" required value={this.state.editing.extension} onChange={this.editField('extension')} ></input>
    								<span className="inputBar"></span><label className="textLabel">Extension</label>
    							</div>

    							<div  style={{display:'inline-block'}} className="snazzyInputBox">
    								<input className="textInput" type="text" required value={this.state.editing.dialString} onChange={this.editField('dialString')} ></input>
    								<span className="inputBar"></span><label className="textLabel">Dial String</label>
    							</div>
                            </div>
                            <div>
                                <div style={{display:'inline-block', padding: '0px 25px'}}>
                                    <div>List in Public Directory</div>

                                    <div className="activeBox" onClick={this.toggle('includeInDirectory')}>
                                        <div className={this.state.editing.includeInDirectory ? "enabled" : "disabled"}></div>
                                    </div>

                                </div>
                                <div style={{display:'inline-block', padding: '0px 25px'}}>
                                    <div>Announce Number at Transfer</div>

                                    <div className="activeBox" onClick={this.toggle('announceTransfer')}>
                                        <div className={this.state.editing.announceTransfer ? "enabled" : "disabled"}></div>
                                    </div>

                                </div>
                            </div>


                            <div className="snazzyInputBox">
                                <div>Text to Speech: Say As... </div>
								<input placeholder={sayAsString} className="textInput" type="text" required value={this.state.editing.sayAs} onChange={this.editField('sayAs')} ></input>
                                <img style={{background:'#2a6aa9', position: 'absolute', right: '0px', bottom: '0px'}} src={this.props.img.speaker} alt="Play Name" onClick={this.playSayAs(this.state.editing)} />
							</div>
                            <br/>
                            <br/>
                            <div>Speech Recognition Aliases</div>
                            <div style={{display: 'flex', flexFlow: 'row wrap', alignContent: 'flex-start', alignItems: 'flex-start' , justifyContent: 'flex-start'}}>
                                {aliasArray}
                            </div>

							<div className="error" style={{padding: '15px'}}>{this.state.error}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button"  onClick={this.conf}>Confirm Directory Entry</div>}
						</div>
					</div>
				)
			}
            console.log(this.props)
			return (
				<div className="viewContent">
					<img src={this.props.img.plus}  className="plusButton" alt="Add" onClick={this.add} />
					<div className="dataHeaders">
						<span style={{flex: '0 0 125px', cursor: 'pointer'}} onClick={this.sort} data-sortby="extension">Extension</span>
						<span style={{flex: '0 0 150px', cursor: 'pointer'}} onClick={this.sort} data-sortby="firstName">First Name</span>
                        <span style={{flex: '0 0 150px', cursor: 'pointer'}} onClick={this.sort} data-sortby="lastName">Last Name</span>
                        <span style={{flex: '0 0 150px', cursor: 'pointer'}} onClick={this.sort} data-sortby="department">Department</span>
                        <span style={{flex: '1 0 100px', cursor: 'pointer'}} onClick={this.sort} data-sortby="sayAs">Say As...</span>
						<span style={{flex: '0 0 80px'}}></span>
					</div>
                    <div className="dataFilters">
						<input style={{flex: '0 0 120px', maxWidth: '120px' }} type="text" onChange={this.filter} value={this.state.filterBy.extension} ref="username" data-filterBy="extension"/>
						<input style={{flex: '0 0 150px', maxWidth: '150px'}} type="text" onChange={this.filter} value={this.state.filterBy.firstName} ref="wholeName"  data-filterBy="firstName"/>
						<input style={{flex: '0 0 150px', maxWidth: '150px'}} type="text" onChange={this.filter} value={this.state.filterBy.lastName} ref="Status"  data-filterBy="lastName"/>
                        <input style={{flex: '0 0 300px', maxWidth: '300px'}} type="text" onChange={this.filter} value={this.state.filterBy.department} ref="Status"  data-filterBy="department"/>
                        <input style={{flex: '1 0 100px', }} type="text" onChange={this.filter} value={this.state.filterBy.sayAs} ref="Status"  data-filterBy="sayAs"/>
						<span style={{flex: '0 0 80px'}} ></span>
					</div>
					<div style={{overflow: 'auto', height: 'calc(100% - 85px)'}}>
						{contacts}
						{edit}
					</div>
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/Views/Directory.js